import React, { useState } from 'react';
import ReactMapGL, { Marker, WebMercatorViewport } from 'react-map-gl';
import { Overview_ListingData_listings } from '../../types/graph/Overview_ListingData';
import * as _ from 'lodash';
import config from '../../config';
import MarkerIcon from '../../assets/icons/CL-Icon-Transparent-32px.png';

type Viewport = {
  width: number | string;
  height: number | string;
  latitude: number;
  longitude: number;
  zoom: number;
};

interface IProps {
  listings: (Overview_ListingData_listings | null)[];
}

const applyToArray = (func: Function, array: Array<number>) =>
  func.apply(Math, array);

const getBounds = (listings: (Overview_ListingData_listings | null)[]) => {
  const lat = listings.map((listing) =>
    _.get(listing, 'property.address.lat', 0)
  );
  const lng = listings.map((listing) =>
    _.get(listing, 'property.address.lng', 0)
  );

  console.log('t1: ', lat);
  console.log('t2: ', lng);

  const cornersLngLat: [[number, number], [number, number]] = [
    [applyToArray(Math.min, lng), applyToArray(Math.min, lat)],
    [applyToArray(Math.max, lng), applyToArray(Math.max, lat)],
  ];

  console.log('t3: ', cornersLngLat);

  const viewport = new WebMercatorViewport({
    width: 600,
    height: 600,
  }).fitBounds(cornersLngLat, { padding: 100 });

  const { longitude, latitude, zoom } = viewport;
  return { longitude, latitude, zoom };
};

const OverviewMap: React.FC<IProps> = ({ listings }) => {
  let latitude = 46.81921;
  let longitude = -53.206893;
  let zoom = 2;

  if (listings.length > 0) {
    const bounds = getBounds(listings);
    if (bounds.zoom > 13) bounds.zoom = 13;
    latitude = bounds.latitude;
    longitude = bounds.longitude;
    zoom = bounds.zoom;
  }

  const [viewport, setViewport] = useState<Viewport>({
    width: '100%',
    height: 470,
    latitude: latitude,
    longitude: longitude,
    zoom: zoom,
  });

  return (
    <div className="rounded-lg overflow-hidden shadow">
      <ReactMapGL
        {...viewport}
        mapboxApiAccessToken={config.map.token}
        onViewportChange={(nextViewport: Viewport) => setViewport(nextViewport)}
        mapStyle="mapbox://styles/mkgo/ckmjw0nio14wn17o4pa8uqase"
      >
        {listings.map((listing) => {
          if (
            listing &&
            _.get(listing, 'property.address.lat', false) &&
            _.get(listing, 'property.address.lng', false)
          ) {
            return (
              <Marker
                offsetTop={-32}
                offsetLeft={-16}
                latitude={listing.property!.address!.lat!}
                longitude={listing.property!.address!.lng!}
              >
                <img className="w-8 h-8" src={MarkerIcon} alt="Listing" />
              </Marker>
            );
          }
          return null;
        })}
      </ReactMapGL>
    </div>
  );
};

export default OverviewMap;
